{
  "v1.compte.acces.aucun_profil": "No profile.",
  "v1.compte.acces.droits": "{{n}} effective rights",
  "v1.compte.acces.herite": "inherited",
  "v1.compte.acces.pose": "granted",
  "v1.compte.acces.propriete": "through ownership",
  "v1.compte.acces.titre": "My access by space",
  "v1.compte.acces.tronque": "List truncated: only the first spaces are shown.",
  "v1.compte.acces.vide": "No access to any space.",
  "v1.compte.annuler": "Cancel",
  "v1.compte.applications.echec": "The application was not revoked.",
  "v1.compte.applications.revoquee": "Application revoked.",
  "v1.compte.applications.revoquer": "Revoke",
  "v1.compte.applications.revoquer_nom": "Revoke application {{nom}}",
  "v1.compte.applications.titre": "Authorised applications",
  "v1.compte.applications.vide": "No authorised application.",
  "v1.compte.apropos.guide": "Open the guide",
  "v1.compte.apropos.texte": "For any question, see the guide or your organisation administration.",
  "v1.compte.apropos.titre": "About and support",
  "v1.compte.code.ANNUAIRE_INDISPONIBLE": "The account directory is unavailable: try again later.",
  "v1.compte.code.APPLICATION_INTROUVABLE": "This application is no longer authorised.",
  "v1.compte.code.CHAMP_GERE_PAR_L_ORGANISATION": "This field is managed by your organisation.",
  "v1.compte.code.CONDITIONS_VERSION_PERIMEE": "A newer version of the terms is in force: read it again.",
  "v1.compte.code.CONFIRMATION_IDENTITE_ECHOUEE": "Incorrect secret: your identity is not confirmed.",
  "v1.compte.code.CONFIRMATION_IDENTITE_REQUISE": "Confirm your identity first (valid for 5 minutes).",
  "v1.compte.code.DELEGATION_DELEGATOR_ROLE_MISSING": "You do not hold this role or profile in this project.",
  "v1.compte.code.DELEGATION_DROIT_RESERVE": "Ownership and reserved rights are never delegated.",
  "v1.compte.code.DELEGATION_INTROUVABLE": "This delegation does not exist.",
  "v1.compte.code.DELEGATION_NON_MEMBRE": "The delegate is not an active member of this project.",
  "v1.compte.code.DELEGATION_PERIODE_INVALIDE": "The period runs from a start to a future end, 90 days at most.",
  "v1.compte.code.DELEGATION_SOI_MEME": "You cannot delegate your profile to yourself.",
  "v1.compte.code.DERNIER_PROPRIETAIRE": "You are the sole owner of objects: transfer their ownership first.",
  "v1.compte.code.DROIT_NON_TENU": "You do not hold the required right.",
  "v1.compte.code.EXPORT_DEJA_EN_COURS": "An export of your data is already in progress.",
  "v1.compte.code.EXPORT_EXPIRE": "The export link has expired: start a new export.",
  "v1.compte.code.EXPORT_INTROUVABLE": "This export does not exist.",
  "v1.compte.code.JETON_EXPIRATION_PLAFOND": "The expiry exceeds the platform ceiling.",
  "v1.compte.code.JETON_INTROUVABLE": "This token no longer exists.",
  "v1.compte.code.JETON_NOM_DEJA_UTILISE": "One of your tokens already has this name.",
  "v1.compte.code.JETON_PORTEE_HORS_DROITS": "A chosen scope exceeds your rights.",
  "v1.compte.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v1.compte.code.SESSION_COURANTE_EXCLUE": "The current session cannot be closed from here.",
  "v1.compte.code.SESSION_INTROUVABLE": "This session no longer exists.",
  "v1.compte.code.STATUT_EXPIRATION_PASSEE": "The status expiry is already past.",
  "v1.compte.code.SUPPRESSION_DEJA_DEMANDEE": "Deletion of your account has already been requested.",
  "v1.compte.code.TROP_DE_TENTATIVES": "Too many attempts: wait before trying again.",
  "v1.compte.code.VALIDATION_ERROR": "An entered value is invalid.",
  "v1.compte.conditions.acceptees": "Terms accepted.",
  "v1.compte.conditions.accepter": "Accept the terms",
  "v1.compte.conditions.aucune": "No version of the terms is in force.",
  "v1.compte.conditions.deconnecter": "Sign out",
  "v1.compte.conditions.deja": "You accepted version {{version}} on {{date}}.",
  "v1.compte.conditions.echec": "The acceptance was not recorded.",
  "v1.compte.conditions.libelle": "Terms of use",
  "v1.compte.conditions.resume": "Summary of changes",
  "v1.compte.conditions.suspendu": "Your journey stays suspended until the terms are accepted.",
  "v1.compte.conditions.texte": "Full text",
  "v1.compte.conditions.titre": "Accept the terms of use",
  "v1.compte.conditions.version": "Version {{version}}, in force since {{date}}",
  "v1.compte.confirmer.confirmer": "Confirm",
  "v1.compte.confirmer.echec": "The confirmation failed.",
  "v1.compte.confirmer.fenetre": "The confirmation lasts 5 minutes.",
  "v1.compte.confirmer.pour_jeton": "Enter your password to create a personal token.",
  "v1.compte.confirmer.requis": "Enter your secret.",
  "v1.compte.confirmer.secret": "Password or second-factor code",
  "v1.compte.confirmer.texte": "Enter your password to confirm a sensitive action.",
  "v1.compte.confirmer.titre": "Confirm my identity",
  "v1.compte.consentements.change": "Consent saved.",
  "v1.compte.consentements.donne": "given",
  "v1.compte.consentements.donner": "Give my consent: {{finalite}}",
  "v1.compte.consentements.echec": "The consent was not changed.",
  "v1.compte.consentements.retire": "withdrawn",
  "v1.compte.consentements.retirer": "Withdraw my consent: {{finalite}}",
  "v1.compte.consentements.titre": "My consents to AI processing",
  "v1.compte.consentements.vide": "No consent requested.",
  "v1.compte.delegations.deleguer": "Delegate my profiles",
  "v1.compte.delegations.donnee": "Given to",
  "v1.compte.delegations.echec": "The delegation was not revoked.",
  "v1.compte.delegations.etat.active": "active",
  "v1.compte.delegations.etat.expired": "ended",
  "v1.compte.delegations.etat.revoked": "revoked",
  "v1.compte.delegations.etat.scheduled": "upcoming",
  "v1.compte.delegations.periode": "from {{debut}} to {{fin}}",
  "v1.compte.delegations.recue": "Received from",
  "v1.compte.delegations.revoquee": "Delegation revoked.",
  "v1.compte.delegations.revoquer": "Revoke",
  "v1.compte.delegations.revoquer_nom": "Revoke the delegation of {{espace}}",
  "v1.compte.delegations.titre": "My delegations",
  "v1.compte.delegations.vide": "No delegation given or received.",
  "v1.compte.deleguer.aucun_espace": "You are a member of no project: nothing to delegate.",
  "v1.compte.deleguer.aucun_membre": "No other active member in this project.",
  "v1.compte.deleguer.aucun_profil": "You hold no profile on this project: nothing to delegate.",
  "v1.compte.deleguer.candidats_erreur": "The project members could not be read.",
  "v1.compte.deleguer.choisir": "Choose a member",
  "v1.compte.deleguer.debut": "Start",
  "v1.compte.deleguer.delegataire": "Delegate",
  "v1.compte.deleguer.delegataire_requis": "Choose the delegate.",
  "v1.compte.deleguer.deleguer": "Delegate",
  "v1.compte.deleguer.echec": "The delegation was not recorded.",
  "v1.compte.deleguer.espace": "Project",
  "v1.compte.deleguer.fin": "End",
  "v1.compte.deleguer.motif": "Reason",
  "v1.compte.deleguer.motif_aide": "At least 5 characters; recorded with the delegation.",
  "v1.compte.deleguer.motif_requis": "The reason needs at least 5 characters.",
  "v1.compte.deleguer.periode_aide": "{{jours}} days at most.",
  "v1.compte.deleguer.profils": "Delegated profiles",
  "v1.compte.deleguer.profils_aide": "The rights passed on are those of the ticked profiles, whatever the role chosen.",
  "v1.compte.deleguer.profils_requis": "Tick at least one profile to delegate.",
  "v1.compte.deleguer.reserve": "Ownership and reserved rights are never delegated.",
  "v1.compte.deleguer.reussie": "Delegation recorded.",
  "v1.compte.deleguer.role": "Delegated role",
  "v1.compte.deleguer.role.contributor": "Contributor",
  "v1.compte.deleguer.role.viewer": "Reader",
  "v1.compte.deleguer.taches": "Entrust my ongoing tasks (approvals and assignments)",
  "v1.compte.deleguer.taches_aide": "Shown to the delegate during the period, returned at the end.",
  "v1.compte.deleguer.titre": "Delegate my profiles during an absence",
  "v1.compte.donnees.titre": "My data",
  "v1.compte.droits_isoles.aucun_espace": "No project: no isolated right to show.",
  "v1.compte.droits_isoles.espace": "Project",
  "v1.compte.droits_isoles.limites": "Set work-in-progress limits",
  "v1.compte.droits_isoles.non_tenue": "not held",
  "v1.compte.droits_isoles.recette": "Run acceptance tests",
  "v1.compte.droits_isoles.regression": "Accept a regression",
  "v1.compte.droits_isoles.tenue": "held",
  "v1.compte.droits_isoles.titre": "Isolated acceptance rights",
  "v1.compte.droits_isoles.vide": "No isolated right in this project.",
  "v1.compte.etat.chargement": "Loading {{quoi}}…",
  "v1.compte.etat.en_cours": "In progress…",
  "v1.compte.etat.erreur": "{{quoi}}: could not be read.",
  "v1.compte.etat.reessayer": "Retry",
  "v1.compte.etat.refus": "{{quoi}}: access denied.",
  "v1.compte.export.actualiser": "Refresh",
  "v1.compte.export.echec": "The export was not started.",
  "v1.compte.export.echec_telechargement": "Downloading the archive failed.",
  "v1.compte.export.etat.en_cours": "Export being prepared.",
  "v1.compte.export.etat.expire": "Link expired: start a new export.",
  "v1.compte.export.etat.pret": "Archive ready.",
  "v1.compte.export.expire": "link valid until {{quand}}",
  "v1.compte.export.lancer": "Export my data",
  "v1.compte.export.suivi": "Export follow-up",
  "v1.compte.export.telecharger": "Download the archive",
  "v1.compte.fermer": "Close",
  "v1.compte.identite.courriel": "Email",
  "v1.compte.identite.nom": "Name",
  "v1.compte.identite.organisation": "Organisation",
  "v1.compte.identite.titre": "Identity",
  "v1.compte.jeton.aucune_portee": "No right to give to a token.",
  "v1.compte.jeton.confirmer_d_abord": "Confirm your identity first: creating a token requires it.",
  "v1.compte.jeton.confirmer_lien": "Confirm my identity",
  "v1.compte.jeton.copiee": "Value copied.",
  "v1.compte.jeton.copier": "Copy the value",
  "v1.compte.jeton.cree": "Token “{{nom}}” created.",
  "v1.compte.jeton.creer": "Create the token",
  "v1.compte.jeton.echec": "The token was not created.",
  "v1.compte.jeton.expiration": "Expiry",
  "v1.compte.jeton.fermer_consequence": "Its value will be lost: you will have to create another token.",
  "v1.compte.jeton.fermer_titre": "Close without copying the token?",
  "v1.compte.jeton.fermer_verbe": "Close",
  "v1.compte.jeton.nom": "Token name",
  "v1.compte.jeton.nom_requis": "Give the token a name.",
  "v1.compte.jeton.plafond": "{{jours}} days at most (until {{date}}).",
  "v1.compte.jeton.portee_requise": "Choose at least one scope.",
  "v1.compte.jeton.portees": "Scopes (bounded by your rights)",
  "v1.compte.jeton.titre": "Create a personal token",
  "v1.compte.jeton.une_seule_fois": "Copy its value now: it will never be shown again.",
  "v1.compte.jeton.valeur_vide": "The token value will appear here, once.",
  "v1.compte.jetons.confirmation_requise": "Creation requires confirming your identity.",
  "v1.compte.jetons.creer": "Create a token",
  "v1.compte.jetons.echec": "The token was not revoked.",
  "v1.compte.jetons.expire": "expires {{quand}}",
  "v1.compte.jetons.revoque": "Token revoked.",
  "v1.compte.jetons.revoquer": "Revoke",
  "v1.compte.jetons.revoquer_nom": "Revoke token {{nom}}",
  "v1.compte.jetons.titre": "My personal tokens",
  "v1.compte.jetons.vide": "No personal token.",
  "v1.compte.lien_fiche_membre": "My member page",
  "v1.compte.lien_preferences": "My preferences",
  "v1.compte.liens": "Account links",
  "v1.compte.niveau.organisation": "organisation",
  "v1.compte.niveau.programme": "programme",
  "v1.compte.niveau.projet": "project",
  "v1.compte.prefs.affichage": "Display and accessibility",
  "v1.compte.prefs.aucun_espace": "No accessible project: the home view and navigation mode are set per project.",
  "v1.compte.prefs.aucun_projet": "No accessible project: only the default level applies.",
  "v1.compte.prefs.contraste_eleve": "High contrast",
  "v1.compte.prefs.daltonisme": "Colour vision",
  "v1.compte.prefs.daltonisme.aucun": "No adjustment",
  "v1.compte.prefs.daltonisme.deuteranopie": "Deuteranopia",
  "v1.compte.prefs.daltonisme.protanopie": "Protanopia",
  "v1.compte.prefs.daltonisme.tritanopie": "Tritanopia",
  "v1.compte.prefs.densite": "Density",
  "v1.compte.prefs.densite.compacte": "Compact",
  "v1.compte.prefs.densite.confortable": "Comfortable",
  "v1.compte.prefs.echec": "Saving failed.",
  "v1.compte.prefs.enregistrer_mode": "Save the mode",
  "v1.compte.prefs.enregistrer_notifications": "Save my notifications",
  "v1.compte.prefs.enregistrer_reglages": "Save my settings",
  "v1.compte.prefs.enregistrer_vue": "Save the home view",
  "v1.compte.prefs.espace": "Project",
  "v1.compte.prefs.fuseau": "Time zone",
  "v1.compte.prefs.fuseau_invalide": "IANA time zone expected (for example Africa/Abidjan).",
  "v1.compte.prefs.herite": "Inherited from the default level",
  "v1.compte.prefs.heures_calmes": "Quiet hours",
  "v1.compte.prefs.heures_calmes.actives": "Turn on quiet hours",
  "v1.compte.prefs.heures_calmes.aide": "Daily range; without a setting, the organisation’s applies; an emergency always gets through.",
  "v1.compte.prefs.heures_calmes.debut": "Start",
  "v1.compte.prefs.heures_calmes.fin": "End",
  "v1.compte.prefs.heures_calmes.invalides": "Distinct start and end required (HH:MM).",
  "v1.compte.prefs.langue": "Language",
  "v1.compte.prefs.langue.en": "English",
  "v1.compte.prefs.langue.fr": "French",
  "v1.compte.prefs.mode": "Navigation mode",
  "v1.compte.prefs.mode.actuel": "Current mode: {{mode}}.",
  "v1.compte.prefs.mode.complete": "Complete",
  "v1.compte.prefs.mode.discovery": "Discovery",
  "v1.compte.prefs.mode_defaut": "Back to the default mode",
  "v1.compte.prefs.mode_enregistre": "Navigation mode saved.",
  "v1.compte.prefs.mode_par_defaut": "Default mode restored.",
  "v1.compte.prefs.mouvement_reduit": "Reduce motion",
  "v1.compte.prefs.niveau.all": "Everything",
  "v1.compte.prefs.niveau.mentions": "Mentions only",
  "v1.compte.prefs.niveau.mute": "Muted",
  "v1.compte.prefs.niveau_defaut": "Default level",
  "v1.compte.prefs.niveau_projet": "Level per project",
  "v1.compte.prefs.notifications": "Notifications",
  "v1.compte.prefs.notifications_enregistrees": "Notifications saved.",
  "v1.compte.prefs.par_espace": "Preferences per project",
  "v1.compte.prefs.raccourcis": "Single-key shortcuts",
  "v1.compte.prefs.raccourcis_aide": "Shortcut list: “?” key. Uncheck to turn them off (WCAG 2.1.4).",
  "v1.compte.prefs.reglages_enregistres": "Settings saved.",
  "v1.compte.prefs.reinitialiser": "Reset the home view",
  "v1.compte.prefs.reinitialiser_consequence": "Your view choice for this project will be erased.",
  "v1.compte.prefs.reinitialiser_titre": "Go back to the suggested view?",
  "v1.compte.prefs.resume": "Notification digest",
  "v1.compte.prefs.resume.actif": "On",
  "v1.compte.prefs.resume.creneaux": "Sent at {{creneaux}} ({{fuseau}}).",
  "v1.compte.prefs.resume.desactive": "Off",
  "v1.compte.prefs.retour_notifications": "Back to notifications",
  "v1.compte.prefs.theme": "Theme",
  "v1.compte.prefs.theme.clair": "Light",
  "v1.compte.prefs.theme.sombre": "Dark",
  "v1.compte.prefs.theme.systeme": "Follow the system",
  "v1.compte.prefs.titre": "My preferences",
  "v1.compte.prefs.vue": "Home view",
  "v1.compte.prefs.vue.actuelle": "Chosen view: {{vue}}.",
  "v1.compte.prefs.vue.administration": "Administration",
  "v1.compte.prefs.vue.architecte": "Architecture",
  "v1.compte.prefs.vue.combinee": "Combined view",
  "v1.compte.prefs.vue.dev": "Development",
  "v1.compte.prefs.vue.metier": "Business",
  "v1.compte.prefs.vue.po": "Product owner",
  "v1.compte.prefs.vue.release": "Release",
  "v1.compte.prefs.vue.scrum_master": "Scrum Master",
  "v1.compte.prefs.vue.sponsor": "Sponsor",
  "v1.compte.prefs.vue.suggeree": "Suggested view",
  "v1.compte.prefs.vue.testeur": "Testing",
  "v1.compte.prefs.vue_enregistree": "Home view saved.",
  "v1.compte.prefs.vue_reinitialisee": "Home view reset.",
  "v1.compte.profil.avatar": "Avatar address",
  "v1.compte.profil.avatar_aide": "https:// address of an image.",
  "v1.compte.profil.champ.courriel": "email",
  "v1.compte.profil.champ.identifiant": "username",
  "v1.compte.profil.champ.nom": "last name",
  "v1.compte.profil.champ.prenom": "first name",
  "v1.compte.profil.champ.role_organisation": "organisation role",
  "v1.compte.profil.echec": "The profile was not saved.",
  "v1.compte.profil.enregistre": "Profile saved.",
  "v1.compte.profil.enregistrer": "Save my profile",
  "v1.compte.profil.geres": "Managed by your organisation, not editable here: {{champs}}.",
  "v1.compte.profil.nom_affiche": "Display name",
  "v1.compte.profil.pronoms": "Pronouns",
  "v1.compte.profil.titre": "Personal profile",
  "v1.compte.profil.visibilite": "Profile visibility",
  "v1.compte.profil.visibilite.organisation": "Whole organisation",
  "v1.compte.profil.visibilite.privee": "Private",
  "v1.compte.profil.visibilite.projets": "My projects",
  "v1.compte.sans_organisation": "Your account belongs to no organisation.",
  "v1.compte.sessions.autres_fermees": "{{n}} other session(s) closed.",
  "v1.compte.sessions.courante": "Current session",
  "v1.compte.sessions.derniere": "last activity {{quand}}",
  "v1.compte.sessions.echec": "The session was not closed.",
  "v1.compte.sessions.fermee": "Session closed.",
  "v1.compte.sessions.fermer": "Close",
  "v1.compte.sessions.fermer_autres": "Close all other sessions",
  "v1.compte.sessions.fermer_nom": "Close session {{ip}}",
  "v1.compte.sessions.navigateur": "Browser",
  "v1.compte.sessions.titre": "My sessions",
  "v1.compte.sessions.vide": "No open session.",
  "v1.compte.statut.absent": "Away",
  "v1.compte.statut.choix": "Status",
  "v1.compte.statut.deleguer": "Delegate my profiles while away",
  "v1.compte.statut.disponible": "Available",
  "v1.compte.statut.echec": "The status was not saved.",
  "v1.compte.statut.enregistre": "Status saved.",
  "v1.compte.statut.enregistrer": "Save my status",
  "v1.compte.statut.exclu": "Away or busy, you are excluded from automatic assignments.",
  "v1.compte.statut.expiration": "Until",
  "v1.compte.statut.message": "Message",
  "v1.compte.statut.occupe": "Busy",
  "v1.compte.statut.titre": "Away status",
  "v1.compte.suppression.confirmer_titre": "Request deletion of your account?",
  "v1.compte.suppression.consequence_admin": "The organisation administration will handle the request.",
  "v1.compte.suppression.consequence_anonyme": "Your contributions will be kept under an anonymous name.",
  "v1.compte.suppression.demandee": "Deletion requested: the administration will handle it.",
  "v1.compte.suppression.demander": "Request deletion of my account",
  "v1.compte.suppression.echec": "The request was not recorded.",
  "v1.compte.suppression.en_cours": "Deletion requested on {{quand}}, awaiting the administration.",
  "v1.compte.suppression.explication": "Deletion is handled by the administration; your contributions remain, under an anonymous name.",
  "v1.compte.suppression.motif": "Reason",
  "v1.compte.suppression.motif_aide": "Optional; 10 to 1,000 characters if given.",
  "v1.compte.suppression.motif_bornes": "The reason must be 10 to 1,000 characters; the request was not sent.",
  "v1.compte.suppression.verbe": "Request",
  "v1.compte.taches.anomalie": "Defect",
  "v1.compte.taches.approbation": "Approval",
  "v1.compte.taches.aucune": "No ongoing task entrusted.",
  "v1.compte.taches.element": "Item",
  "v1.compte.taches.titre": "Tasks entrusted during the delegation",
  "v1.compte.titre": "My profile and access",
  "v1.compte.version.inconnue": "Unknown version.",
  "v1.compte.version.texte": "Version {{version}} (revision {{revision}})",
  "v1.compte.version.titre": "Tool version"
}
